import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Lock, ShieldCheck, User } from 'lucide-react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { DmpLogo } from '../../components/brand/DmpLogo';
import { BdFlag } from '../../components/brand/BdFlag';
export function AdminLogin() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('dmp.admin01');
  const [password, setPassword] = useState('••••••••••');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId || !password) {
      setError('ইউজার আইডি ও পাসওয়ার্ড আবশ্যক');
      return;
    }
    setError('');
    setLoading(true);
    window.setTimeout(() => navigate('/admin'), 900);
  };
  return <div className="grid min-h-[calc(100vh-48px)] w-full bg-white lg:grid-cols-[1.1fr_1fr]" data-id="element-702" data-mp="1ptx9ohoolyft">
      <div className="relative hidden flex-col justify-between bg-navy-800 p-10 text-white lg:flex" data-id="element-703" data-mp="1wo5e69quskuz">
        <div className="flex items-center gap-2 text-sm text-navy-200" data-id="element-704" data-mp="20p794edqmar5">
          <BdFlag width={26} data-id="element-705" data-mp="20rbj9e28c5zv" /> গণপ্রজাতন্ত্রী বাংলাদেশ সরকার
        </div>
        <div data-id="element-706" data-mp="25p3dieqck478">
          <DmpLogo size={120} data-id="element-707" data-mp="25mh2240c54jq" />
          <h1 className="mt-6 font-heading text-3xl font-bold" data-id="element-708" data-mp="2anejufhfnwkp">ঢাকা মেট্রোপলিটন পুলিশ</h1>
          <p className="mt-2 text-lg text-navy-100" data-id="element-709" data-mp="1czw9x1c1cof4">সিএনজি ও চালক যাচাই ব্যবস্থাপনা</p>
          <div className="mt-8 grid max-w-md grid-cols-3 gap-3" data-id="element-710" data-mp="1cy1rbto8l8e7">
            {[['১৭,০০০', 'সিএনজি (প্রথম পর্যায়)'], ['৮টি', 'ট্রাফিক বিভাগ'], ['২৪/৭', 'রোডসাইড যাচাই']].map(([v, l]) => <div key={l} className="rounded-md border border-sidebar-border bg-sidebar-accent p-3" data-id="element-711" data-mp="1rpu5418duedt">
                <p className="font-heading text-xl font-bold" data-id="element-712" data-mp="u8d82xtqzgeo">{v}</p>
                <p className="text-[11px] text-navy-200" data-id="element-713" data-mp="z87yz1diw5zq">{l}</p>
              </div>)}
          </div>
        </div>
        <p className="text-xs text-navy-300" data-id="element-714" data-mp="r6qo9vegs6kf">ট্রাফিক বিভাগ • ঢাকা মেট্রোপলিটন পুলিশ • ৩৬ শহীদ ক্যাপ্টেন মনসুর আলী সরণি, রমনা, ঢাকা</p>
        <div className="absolute bottom-0 left-0 right-0 flex h-1.5" data-id="element-715" data-mp="n5yff39i83oo">
          <span className="flex-1 bg-bdgreen-600" data-id="element-716" data-mp="10wa6qzy9lyer" />
          <span className="w-16 bg-flagred" data-id="element-717" data-mp="vyie23psq89i" />
          <span className="flex-1 bg-bdgreen-600" data-id="element-718" data-mp="vztim5r2fk1o" />
        </div>
      </div>
      <div className="flex items-center justify-center p-6" data-id="element-719" data-mp="88efiargsypd">
        <form onSubmit={submit} className="w-full max-w-sm" data-id="element-720" data-mp="8ar4h7vn49bx">
          <div className="mb-6 flex flex-col items-center text-center lg:hidden" data-id="element-721" data-mp="48np485uokld">
            <DmpLogo size={72} data-id="element-722" data-mp="i7dknjd0uc7m" />
            <p className="mt-2 font-semibold text-navy-900" data-id="element-723" data-mp="i8eytwpc3etk">ঢাকা মেট্রোপলিটন পুলিশ</p>
          </div>
          <h2 className="font-heading text-2xl font-bold text-navy-900" data-id="element-724" data-mp="d6pnsh24315h">লগইন</h2>
          <p className="mb-6 text-sm text-slate-500" data-id="element-725" data-mp="1tkz8n175a7rk">ওয়েব অ্যাডমিনিস্ট্রেশন পোর্টালে প্রবেশ করুন</p>
          <label htmlFor="a-user" className="mb-1 block text-sm font-medium text-slate-700" data-id="element-726" data-mp="1omecpdyxea8x">ইউজার আইডি</label>
          <div className="relative mb-4" data-id="element-727" data-mp="36j9cwfn8lel7">
            <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-728" data-mp="3bjnkjwkxemip" />
            <Input id="a-user" value={userId} onChange={e => setUserId(e.target.value)} className="h-11 pl-9" data-id="element-729" data-mp="2xke36tkzhmd5" />
          </div>
          <label htmlFor="a-pass" className="mb-1 block text-sm font-medium text-slate-700" data-id="element-730" data-mp="32k8u2x4reby7">পাসওয়ার্ড</label>
          <div className="relative mb-2" data-id="element-731" data-mp="3qa35da9fjsgc">
            <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-732" data-mp="3qb5wnjanzwws" />
            <Input id="a-pass" type="password" value={password} onChange={e => setPassword(e.target.value)} className="h-11 pl-9" data-id="element-733" data-mp="3uc7xu5o56j1e" />
          </div>
          {error && <p className="mb-2 text-xs text-red-600" data-id="element-734" data-mp="3lgs7hymlim0k">{error}</p>}
          <div className="mb-5 flex items-center justify-between text-xs" data-id="element-735" data-mp="d2jlj9ekwthd">
            <label className="flex items-center gap-1.5 text-slate-600" data-id="element-736" data-mp="d0f8o1ypck4y"><input type="checkbox" defaultChecked className="accent-navy-800" data-id="element-737" data-mp="htrxac3dsqxp" /> মনে রাখুন</label>
            <button type="button" className="font-medium text-navy-600" data-id="element-738" data-mp="2pdcoquq6an4i">পাসওয়ার্ড পুনরুদ্ধার</button>
          </div>
          <Button type="submit" disabled={loading} className="h-11 w-full text-[15px]" data-id="element-739" data-mp="2kc5fsscanhw9">
            {loading && <Loader2 className="h-4 w-4 animate-spin" data-id="element-740" data-mp="2gc53bd8r9gru" />} লগইন
          </Button>
          <p className="mt-4 flex items-center justify-center gap-1.5 text-xs text-slate-500" data-id="element-741" data-mp="2be3j2ozlfbes">
            <ShieldCheck className="h-4 w-4 text-bdgreen-600" data-id="element-742" data-mp="381rdtcgxjr2o" /> দ্বি-স্তর যাচাই (OTP) সক্রিয় • সকল কার্যক্রম অডিট লগে সংরক্ষিত
          </p>
        </form>
      </div>
    </div>;
}